import axiosInstance from '../utils/axios';

/**
 * Creates a Biostar account for the logged-in student (SP-side testing only).
 * Backend route: POST /biostar/createAccount
 */
export const CreateAccountService = async () => {
    return await axiosInstance().post('/biostar/createAccount');
};

/**
 * Enrolls the photo already uploaded and validated via UploadPhotoService or
 * RelayPhotoFromMobileService - the spec's single "Submit" button.
 * Backend route: POST /biostar/submitPhoto
 */
export const SubmitPhotoService = async () => {
    return await axiosInstance().post('/biostar/submitPhoto');
};

/**
 * Uploads a photo (desktop file pick or webcam capture) to a temp slot and
 * validates it against Biostar right away.
 * Takes FormData with an `image` field, matching RelayPhotoFromMobileService.
 * Backend route: POST /biostar/uploadPhoto
 */
export const UploadPhotoService = async (formData) => {
    return await axiosInstance().post('/biostar/uploadPhoto', formData);
};

/**
 * Mints the signed, short-lived securityToken for one mobile relay session, bound
 * server-side to the logged-in student and embedded in the QR code.
 * Backend route: POST /biostar/startMobileUploadSession
 */
export const StartMobileUploadSessionService = async () => {
    return await axiosInstance().post('/biostar/startMobileUploadSession');
};

/**
 * Relays a photo from the Mobile Scanning Page to the desktop session, which gets
 * the server's verdict over the websocket.
 * Takes FormData with `securityToken` and `image` - multipart rather than base64,
 * which would inflate the payload ~33% over a slow mobile uplink.
 * Backend route: POST /biostar/relayPhotoFromMobile
 */
export const RelayPhotoFromMobileService = async (formData) => {
    return await axiosInstance().post('/biostar/relayPhotoFromMobile', formData);
};

/**
 * Delete Photo (unenroll)
 * Backend route: POST /biostar/deletePhoto
 */
export const DeletePhotoService = async () => {
    return await axiosInstance().post('/biostar/deletePhoto');
};

/**
 * Returns the student's current biometric onboarding status.
 * Backend route: GET /biostar/getStatus
 */
export const GetStatusService = async () => {
    return await axiosInstance().get('/biostar/getStatus');
};
